export const statusSearchOptions = [
    {
        value: "All", label: "All"
    },
    {
        value: "Active", label: "Active"
    },
    {
        value: "Inactive", label: "Inactive"
    },
];
